/* <cs-scroll-bar> draws the position of a swipe row (the track of the <cs-carousel> it sits in) as a thin bar. */
class ScrollProgress extends HTMLElement {
  connectedCallback() {
    this.track = this.closest('cs-carousel')?.querySelector('[data-track]');
    if (!this.track) return;
    this.onScroll = () => this.update();
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.resizeObserver = new ResizeObserver(this.onScroll);
    this.resizeObserver.observe(this.track);
    this.update();
  }
  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }
  update() {
    const { scrollWidth, clientWidth } = this.track;
    const scrollLeft = Math.abs(this.track.scrollLeft);
    const max = scrollWidth - clientWidth;
    if (max <= 2) { this.hidden = true; return; }
    this.hidden = false;
    const size = Math.max(8, (clientWidth / scrollWidth) * 100);
    const position = Math.min(1, scrollLeft / max) * (100 - size);
    this.style.setProperty('--progress-size', size.toFixed(2));
    this.style.setProperty('--progress-pos', position.toFixed(2));
  }
}
if (!customElements.get('cs-scroll-bar')) customElements.define('cs-scroll-bar', ScrollProgress);
